import { FORM_VALIDATION_MSG } from "../constants";
const getDefaultEditReasonInfo = (data) => {
  return {
    editReasonCode: data?.editReasonCode ?? "",
    contactName: data?.contactName ?? "",
    callTime: data?.callTime ?? "",
    comments: data?.comments ?? "",
  };
};

const getDefaultEditReasonErrorInfo = () => {
  return {
    editReasonCode: "",
    contactName: "",
    callTime: "",
    comments: "",
  };
};

const getEditReasonError = (value, isDateTimeUpdated) => {
  if (!value && isDateTimeUpdated) {
    return FORM_VALIDATION_MSG.REQUIRED;
  }
  return null;
};

const getCommentsError = (value, editReasonInfo) => {
  if (editReasonInfo.editReasonCode && !value) {
    return FORM_VALIDATION_MSG.REQUIRED;
  }
  return null;
};

const getContactNameError = (value, isCustomerDetailsRequired) => {
  if (isCustomerDetailsRequired && !value) {
    //contact name and call time fields are required only if isCustomerDetailsRequired is true
    return FORM_VALIDATION_MSG.REQUIRED;
  }
  return null;
};

const getCallTimeError = (value, isCustomerDetailsRequired) => {
  return getContactNameError(value, isCustomerDetailsRequired);
};

const getFieldError = ({
  fieldName,
  value,
  isDateTimeUpdated,
  editReasonInfo,
  editCodeList
}) => {
  const isCustomerDetailsRequired = checkIfCustomerDetailsRequired(editReasonInfo, editCodeList);
  switch (fieldName) {
    case "editReasonCode":
      return getEditReasonError(value, isDateTimeUpdated);
    case "contactName":
      return getContactNameError(value, isCustomerDetailsRequired);
    case "callTime":
      return getCallTimeError(value, isCustomerDetailsRequired);
    case "comments":
      return getCommentsError(value, editReasonInfo);
  }
};

const getEditReasonErrorInfo = (editReasonInfo, isDateTimeUpdated, editCodeList) => {
  let errorInfo = {};
  Object.keys(editReasonInfo).forEach((fieldName) => {
    errorInfo[fieldName] = getFieldError({
      fieldName,
      value: editReasonInfo[fieldName],
      isDateTimeUpdated,
      editReasonInfo,
      editCodeList
    });
  });
  return errorInfo;
};

const checkIfCustomerDetailsRequired = (editReasonInfo, editCodeList) => {
  if (!editReasonInfo?.editReasonCode || !editCodeList?.length) {
    return false;
  }

  const currentReasonCode = editCodeList.find(
    (code) => code.value === editReasonInfo.editReasonCode
  );

  return currentReasonCode?.isCustomerDetailsRequired ?? false;
}

export {
  getDefaultEditReasonInfo,
  getDefaultEditReasonErrorInfo,
  getFieldError,
  getEditReasonErrorInfo,
};
